/**
 * Façon dont une échelle se présente au répondant : une suite d'icônes à désigner, une suite de
 * nombres, ou des libellés. Les valeurs sont celles du discriminant renvoyé par l'API.
 *
 * La distinction commande le premier cran : une échelle d'icônes se note toujours depuis un — il n'y
 * a pas d'icône qui vaille zéro — là où une échelle chiffrée part d'où son paramétrage le dit.
 */
export enum REPRESENTATION {
    VISUAL = 'VISUAL',
    NUMBER = 'NUMBER',
    TEXT = 'TEXT',
}
